<template>
  <div />
</template>

<script>
import logger from "@/utils/logger";
import appSetup from "@/utils/app-setup";

export default {
  name: "vis-splash-screen",
  data() {
    return {
      loading: false,
      error: false
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      try {
        this.loading = true;
        await appSetup();
        this.$emit("loaded");
      } catch (e) {
        logger.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
